export default {
  namespaced: true,
  state: {
    todos: [],
    isLoading: false,
  },
  mutations: {
    SET_TODOS(state, todos) {
      state.todos = todos;
    },
    ADD_TODO(state, todo) {
      state.todos.push(todo);
    },
    UPDATE_TODO(state, { id, done }) {
      const todo = state.todos.find((t) => t.id === id);
      if (todo) todo.done = done;
    },
    REMOVE_TODO(state, id) {
      state.todos = state.todos.filter((t) => t.id !== id);
    },
    SET_LOADING(state, value) {
      state.isLoading = value;
    },
  },
  actions: {
    fetchTodos({ commit }) {
      commit("SET_LOADING", true);
      return this.$http
        .get("oliver-todos")
        .then((res) => {
          commit("SET_TODOS", res.data.data);
        })
        .catch((err) => {
          if (!err.accessDenied) console.error(err);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },
    createTodo({ commit }, { text, type }) {
      return this.$http
        .post("oliver-todos", { text, type })
        .then((res) => {
          commit("ADD_TODO", res.data.data);
        })
        .catch((err) => {
          if (!err.accessDenied) console.error(err);
        });
    },
    updateTodo({ commit }, { id, done }) {
      commit("UPDATE_TODO", { id, done });
      return this.$http.put(`oliver-todos/${id}`, { done }).catch((err) => {
        commit("UPDATE_TODO", { id, done: !done });
        if (!err.accessDenied) console.error(err);
      });
    },
    deleteTodo({ commit }, id) {
      commit("REMOVE_TODO", id);
      return this.$http.delete(`oliver-todos/${id}`).catch((err) => {
        if (!err.accessDenied) console.error(err);
      });
    },
  },
};
